// extracted by mini-css-extract-plugin
module.exports = {"orderStatusWrapper":"v1_orderStatusWrapper__honwG"};